import type { ReactNode } from "react";

interface Props {
  title: string;
  editLabel: string;
  // Opens this part of the change request project (a full-page link).
  href: string;
  empty?: boolean;
  error?: string | null;
  children?: ReactNode;
}

// One part of the change request project on Show. The link always shows, so
// an empty or failed section still leads to where it's edited.
const ShowSection = ({ title, editLabel, href, empty = false, error = null, children }: Props) => (
  <section className="mb-4">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h6 className="mb-0">{title}</h6>
      <a className="btn btnSeawhite" href={href}>
        {editLabel}
      </a>
    </div>
    {error ? (
      <p className="text-danger">{error}</p>
    ) : empty ? (
      <p className="text-muted">None on this change request.</p>
    ) : (
      children
    )}
  </section>
);

export default ShowSection;
